import { PageLayoutDefaultErrorPage404 } from "@sis/react-library";
import { ErrorPageProps } from "./ErrorPageProps";

export const ErrorPage404 = () => {

  return (
    <PageLayoutDefaultErrorPage404
      {...ErrorPageProps()}
    />
  )
}
